import { useState } from "react";
// BOOTSTRAP
import { useAccordionButton } from "react-bootstrap";
// ICONS
import { MinusIcon, PlusIcon } from "@/public/icons/icons";
// STYLE
import s from "./ServiceClientsToggle.module.scss";

interface CustomToggle {
  className?: string;
  title: string;
  eventKey: string;
}

export default function ServiceClientsToggle({ title, eventKey, className }: CustomToggle) {
  const [open, setOpen] = useState(false);
  const controlledClick = useAccordionButton(eventKey, () => setOpen(!open));

  return (
    <div
      onClick={controlledClick}
      className={`${s.customAccordionContainer}} ${className} px-3 fw-semibold`}
      style={{
        cursor: "pointer",
        justifyContent: "space-between",
        height: "3.5rem",
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
      }}
    >
      <p className="mb-0 pe-3" style={{ color: open ? "red" : "black" }}>
        {title}
      </p>
      {open ? <MinusIcon width="18" height="18" color="red" /> : <PlusIcon width="18" height="18" color="black" />}
    </div>
  );
}
